import { navigateTo } from '../Money/utils/constants';

export default function generalEventListeners(event) {
  if (!event || !event.type) {
    return false;
  }

  switch (event.type) {
    case 'Hurdlr.IMPORT_CSV_LEARN_MORE': // redirect Help Center links
      navigateTo('https://intercom.help/zenbusiness/en');
      break;
    case 'Hurdlr.SEND_INVOICE':
      navigateTo('invoices');
      break;
    default:
      break;
  }

  return true;
}
